export const TutorCrmData = [
  {
    title: 'Student Management',
    description:
      'Easily add and organize students, keeping all their academic records in one place for seamless tracking and communication.',
    img: '/images/tutor-crm/student-management.png',
    isImageLeft: true,
  },
  {
    title: 'Academic Offerings and Sessions',
    description:
      'Create and manage tutoring sessions with structured academic offerings that students can book effortlessly.',
    img: '/images/tutor-crm/sessions.png',
    isImageLeft: false,
  },
  {
    title: 'AI-Generated Study Guides',
    description:
      'Generate personalized study materials based on student needs, helping them grasp concepts faster and more effectively.',
    img: '/images/tutor-crm/study-guide.png',
    isImageLeft: true,
  },
  {
    title: 'Smart Practice Tests & Assignments',
    description:
      'Assess student progress with AI-generated practice tests and assignments tailored to their strengths and weaknesses.',
    img: '/images/tutor-crm/assignments.png',
    isImageLeft: false,
  },
  {
    title: 'AI-Powered Session Plans',
    description:
      'Save hours of prep time with structured AI-generated lesson plans that adapt to student performance.',
    img: '/images/tutor-crm/session-plan.png',
    isImageLeft: true,
  },
  {
    title: 'Student Notes & Document Sharing',
    description:
      'Access and review class notes, uploaded documents, and shared resources to enhance lesson effectiveness.',
    img: '/images/tutor-crm/notes.png',
    isImageLeft: false,
  },
  {
    title: 'Seamless Communication & Video Calls',
    description:
      'Message students, share updates, and conduct live video sessions—all within the platform.',
    img: '/images/tutor-crm/video-calls.png',
    isImageLeft: true,
  },
];
